import { CartItem } from '../models/CartItem';
import { Product } from '../models/Product';

import { potentialCartItemMatches } from 'common/api/e-comm/utils/potentialCartItemMatches';

export const getCartItemRebate = (cartItem: CartItem, product: Product): number => {
    const [firstMatch, ...matches] = potentialCartItemMatches(cartItem, product);
    if (!firstMatch || matches.some((variant) => variant.rebate !== firstMatch.rebate)) {
        return product.rebate;
    }
    return firstMatch.rebate;
};
